import React, {useCallback, useContext, useEffect, useState} from 'react'
import {Col, Form, Row} from "react-bootstrap";
import {useHistory} from "react-router-dom";
import {WireTemplatesContext} from "./context";
import {SecurityContext} from "context/security";
import * as URL from "service/UrlConstant";
import WireTemplateWizardLayout from "./WireTemplateWizardLayout";
import ShiftEnterPopupMessage from "components/ShiftEnterPopupMessage";
import {
    getWireTemplateStepUrl,
    shouldNavigateToWireTemplateStep,
    WIRE_TEMPLATE_STEP_URL
} from "./AddNewWireTemplateStep1";

const debtorFields = [
    [
        {label: 'Debtor BIC', name: 'debtorBIC', md: 3, maxLength: 50},
        {label: 'Debtor Name', name: 'debtorName', md: 3, maxLength: 255, required: true},
        {label: 'Debtor Department', name: 'debtorDepartment', md: 3, maxLength: 70},
        {label: 'Sub Department', name: 'debtorSubDepartment', md: 3, maxLength: 70},
    ],
    [
        {label: 'Street Name', name: 'debtorStreetName', md: 4, maxLength: 70},
        {label: 'Building Number', name: 'debtorBuildingNumber', md: 2, maxLength: 16},
        {label: 'Building Name', name: 'debtorBuildingName', md: 4, maxLength: 35},
        {label: 'Floor', name: 'debtorFloor', md: 2, maxLength: 70},
    ],
    [
        {label: 'Post Box', name: 'debtorPostBox', md: 2, maxLength: 16},
        {label: 'Room', name: 'debtorRoom', md: 2, maxLength: 70},
        {label: 'Post Code', name: 'debtorPostCode', md: 2, maxLength: 16},
        {label: 'Town Name', name: 'debtorTownName', md: 3, maxLength: 35, required: true},
        {label: 'Town Location Name', name: 'debtorTownLocationName', md: 3, maxLength: 35},
    ],
    [
        {label: 'District Name', name: 'debtorDistrictName', md: 5, maxLength: 35},
        {label: 'Province', name: 'debtorProvince', md: 4, maxLength: 35},
        {label: 'Country', name: 'debtorCountry', md: 3, maxLength: 2, type: 'country', required: true},
    ],
];

const hasValue = (value) => value !== undefined && value !== null && value.toString().trim() !== '';

export const validateStep4 = (addWireTemplateState = {}) => {
    let errors = {}
    const {
        debtorName,
        debtorTownName,
        debtorCountry,
    } = addWireTemplateState;

    if (!hasValue(debtorName)) {
        errors['debtorName'] = 'Please enter debtor name'
    }

    if (!hasValue(debtorTownName)) {
        errors['debtorTownName'] = 'Please enter debtor town name'
    }

    if (!hasValue(debtorCountry)) {
        errors['debtorCountry'] = 'Please select debtor country'
    }

    return errors
}

export default function AddNewWireTemplateStep4() {

    const history = useHistory();
    const {addWireTemplateState, setAddWireTemplateState, clearAddNewWireTemplateState} = useContext(WireTemplatesContext);
    const {makeGetRequestNoParams} = useContext(SecurityContext);
    const [countries, setCountries] = useState([]);
    const [formErrors, setFormErrors] = useState({});

    const currentStepPage = '4'
    const backStepPage = '3'
    const nextStepPage = '5'

    const getCountries = useCallback(() => {
        const onSuccessResponse = (res) => {
            if (res.data) {
                setCountries(res.data);
            }
        }

        const onErrorResponse = (err) => {
            console.log("Error on get unique iso country code country name: ", err);
        }

        makeGetRequestNoParams(URL.COUNTRY_LIST_COUNTRY_NAME, onSuccessResponse, onErrorResponse)
    }, [makeGetRequestNoParams])

    useEffect(() => {
        getCountries()
    }, [getCountries])
    useEffect(() => {
        if (shouldNavigateToWireTemplateStep(currentStepPage, addWireTemplateState?.newPageStep)) {
            history.push(getWireTemplateStepUrl(addWireTemplateState.newPageStep))
        }
    }, [addWireTemplateState?.newPageStep, history])

    const handleChange = (e) => {
        const {name, value} = e.currentTarget;
        setAddWireTemplateState({...addWireTemplateState, [name]: value});
        if (formErrors[name]) {
            setFormErrors(previousErrors => ({...previousErrors, [name]: ''}))
        }
    }

    const handleClear = (e) => {
        e.preventDefault();
        clearAddNewWireTemplateState();
        setFormErrors({});
    }

    const handleBack = (e) => {
        e.preventDefault();
        const newAddWireTemplateState = {...addWireTemplateState}
        newAddWireTemplateState['newPageStep']=backStepPage
        setAddWireTemplateState(newAddWireTemplateState)
        history.push(WIRE_TEMPLATE_STEP_URL + backStepPage);
    }

    const handleNext = (e) => {
        e.preventDefault();

        const errors = validateStep4(addWireTemplateState);
        if (Object.keys(errors).length !== 0) {
            setFormErrors(errors);
            return
        }

        const newAddWireTemplateState = {...addWireTemplateState}
        newAddWireTemplateState['newPageStep']=nextStepPage
        setAddWireTemplateState(newAddWireTemplateState)
        history.push(WIRE_TEMPLATE_STEP_URL + nextStepPage);
    }

    const renderRequiredMarker = (field) => field.required ? <span className='red-cell'>*</span> : null;

    const renderField = (field) => (
        <Col md={field.md} key={field.name}>
            <Form.Group controlId={`formWireTemplateStep5${field.name}`} className={field.type === 'country' ? 'td-select' : ''}>
                <Form.Label column={false} className="filter-input-label">{field.label} {renderRequiredMarker(field)}</Form.Label>
                {field.type === 'country' ?
                    <Form.Control as="select" name={field.name} value={addWireTemplateState[field.name] || ''} onChange={handleChange}
                                  isInvalid={!!formErrors[field.name]}>
                        <option value={''}>Select</option>
                        {countries.map(country => (
                            <option key={country.countryCode} value={country.countryCode}>{country.country}</option>
                        ))}
                    </Form.Control> :
                    <Form.Control
                        name={field.name}
                        value={addWireTemplateState[field.name] || ''}
                        maxLength={field.maxLength}
                        onChange={handleChange}
                        isInvalid={!!formErrors[field.name]}
                    />
                }
                <Form.Control.Feedback type={'invalid'}>
                    <b><i className="bi bi-exclamation-circle"></i>{formErrors[field.name]}</b>
                </Form.Control.Feedback>
            </Form.Group>
        </Col>
    )

    return (
        <WireTemplateWizardLayout currentStep={4} stepTitle="Debtor Details">
            <ShiftEnterPopupMessage />
            <Form>
                {debtorFields.map((fieldRow, index) => (
                    <Row key={index}>
                        {fieldRow.map(renderField)}
                    </Row>
                ))}

                <div className="awt-actions">
                    <button className="btn td-btn-secondary-clear" onClick={handleClear}>Clear</button>
                    <button className="btn td-btn-secondary-clear" onClick={handleBack}>Back</button>
                    <button className="btn td-btn-primary-light" onClick={handleNext}>Next</button>
                </div>
            </Form>
        </WireTemplateWizardLayout>
    )
}


